export function InitScrollToTop() {
    const backTop = document.querySelector('.js-back-to-top');

    if (backTop) {
        const dataElement = backTop.getAttribute('data-element');
        const scrollElement = dataElement ? document.querySelector(dataElement) : window;
        let scrollOffsetInit = parseInt(backTop.getAttribute('data-offset-in')) || parseInt(backTop.getAttribute('data-offset')) || 0;
        let scrollOffsetOutInit = parseInt(backTop.getAttribute('data-offset-out')) || 0;
        let scrollOffset = 0;
        let scrollOffsetOut = 0;
        let scrolling = false;

        let targetIn = backTop.getAttribute('data-target-in') ? document.querySelector(backTop.getAttribute('data-target-in')) : false;
        let targetOut = backTop.getAttribute('data-target-out') ? document.querySelector(backTop.getAttribute('data-target-out')) : false;

        updateOffsets();

        backTop.addEventListener('click', function (event) {
            event.preventDefault();

            // Prevent double-click interference
            backTop.disabled = true;

            const targetElement = document.getElementById(backTop.getAttribute('href').replace('#', ''));

            if (!window.requestAnimationFrame) {
                (dataElement ? scrollElement : window).scrollTo(0, 0);
                reenableButton();
            } else {
                smoothScrollToTop(dataElement ? scrollElement : window, reenableButton);
            }

            moveFocus(targetElement);
        });

        checkBackToTop();

        if (scrollOffset > 0 || scrollOffsetOut > 0) {
            scrollElement.addEventListener('scroll', function () {
                if (!scrolling) {
                    scrolling = true;
                    (!window.requestAnimationFrame)
                        ? setTimeout(checkBackToTop, 250)
                        : window.requestAnimationFrame(checkBackToTop);
                }
            });
        }

        function checkBackToTop() {
            updateOffsets();
            let windowTop = scrollElement.scrollTop || document.documentElement.scrollTop;
            if (!dataElement) windowTop = window.scrollY || document.documentElement.scrollTop;

            let condition = windowTop >= scrollOffset;

            if (scrollOffsetOut > 0) {
                condition = (windowTop >= scrollOffset) && (window.innerHeight + windowTop < scrollOffsetOut);
            }

            backTop.classList.toggle('back-to-top--is-visible', condition);
            scrolling = false;
        }

        function updateOffsets() {
            scrollOffset = getOffset(targetIn, scrollOffsetInit, true);
            scrollOffsetOut = getOffset(targetOut, scrollOffsetOutInit);
        }

        function getOffset(target, startOffset, useBottom = false) {
            let offset = 0;

            if (target) {
                let windowTop = scrollElement.scrollTop || document.documentElement.scrollTop;
                if (!dataElement) windowTop = window.scrollY || document.documentElement.scrollTop;

                let rect = target.getBoundingClientRect();
                offset = useBottom ? rect.bottom : rect.top;
                offset = offset + windowTop;
            }

            if (startOffset) {
                offset += parseInt(startOffset);
            }

            return offset;
        }

        function moveFocus(element) {
            if (!element) element = document.body;
            element.focus();

            if (document.activeElement !== element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
            }
        }

        function smoothScrollToTop(scrollTarget, callback) {
            const current = scrollTarget.scrollTop || window.scrollY || document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const viewportHeight = window.innerHeight;
            const atBottom = Math.abs(viewportHeight + current - scrollHeight) <= 1;

            const done = () => {
                if (callback) setTimeout(callback, 500);
            };

            if (atBottom) {
                scrollTarget.scrollTo(0, current - 1);
                requestAnimationFrame(() => {
                    scrollTarget.scrollTo({ top: 0, behavior: 'smooth' });
                    done();
                });
            } else {
                scrollTarget.scrollTo({ top: 0, behavior: 'smooth' });
                done();
            }
        }

        function reenableButton() {
            backTop.disabled = false;
        }
    }
}